if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',

    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }
      // Automatically resume playback if paused when modal is closed
      hide() {
        super.hide();
        playIfPaused();

      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
            'data-media-id',
          )}"])`,
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedias = this.querySelectorAll(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`,
        );
        const activeMedia = activeMedias[0];
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        activeMedias.forEach((element) => {
          element.classList.add('active');
        });
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    },
  );
}

// Function to simulate a click on the play button after a delay
function clickPlayButton() {
  setTimeout(function () {
    const playButton = document.querySelector('.deferred-media__poster');
    playButton?.click();
  }, 1000);
}

// Function to play the video if paused after a delay
function playIfPaused() {
  setTimeout(function () {
    const video = document.querySelector('.video');
    if (video?.paused) {
      video?.play();
    }
  }, 2000);
}

clickPlayButton();
